const CATEGORIES_FACETS = {
  platformsSupported: [
    { name: 'Web-based', text: 'Web-based' },
    { name: 'iPhone', text: 'iPhone app' },
    { name: 'Android', text: 'Android app' },
    { name: 'Windows Phone', text: 'Windows Phone app' },
  ],
  typicalCustomers: [
    { name: 'Freelancers', text: 'Freelancers' },
    { name: 'Small Business', text: 'Small businesses' },
    { name: 'Mid Size Business', text: 'Mid size businesses' },
    { name: 'Large Enterprises', text: 'Large enterprises' },
  ],
  supports: [
    { name: 'Phone Support', text: 'Phone' },
    { name: 'Email/Help Desk', text: 'Online' },
    { name: 'Knowledge Base', text: 'Knowledge base' },
    { name: 'Video Tutorials', text: 'Video tutorials' },
  ],
}

const LIMIT_OVERVIEW_LENGTH = 120

export { CATEGORIES_FACETS, LIMIT_OVERVIEW_LENGTH }
